import SocialMirrorLogo from '@/assets/socialMirror/SocialMirrorLogo.svg?react'
import SocialMirrorLogoDark from '@/assets/socialMirror/SocialMirrorLogoDark.svg?react'
import { Chip } from '@/components/Chip/Chip'
import { SidebarTrigger } from '@/components/ui/sidebar'
import { useAppSelector } from '@/hooks/redux'
import { selectIsDarkMode } from '@/store/api/ui/ui.selector'

import type { ProdDevAssetsTypes } from './WecheckEnviromentDistinction.types'

export const WecheckEnviromentDistinction = ({
  enviroment,
}: ProdDevAssetsTypes) => {
  const isDev = enviroment !== 'production'
  const isDarkMode = useAppSelector(selectIsDarkMode)

  return (
    <div className="flex items-center gap-2 group-data-[collapsible=icon]:flex-col p-4 bg-baseColor justify-between">
      <div className="flex items-center gap-2">
        {isDarkMode && (
          <SocialMirrorLogoDark
            width={25}
            height={25}
            className="flex-shrink-0"
          />
        )}
        {!isDarkMode && (
          <SocialMirrorLogo width={25} height={25} className="flex-shrink-0" />
        )}
        <p className="text-sm font-medium tracking-tight whitespace-nowrap group-data-[collapsible=icon]:hidden">
          Social Mirror
        </p>
      </div>

      <div className="flex items-center group-data-[collapsible=icon]:w-min gap-2">
        {isDev ? (
          <span className="text-primaryColor group-data-[collapsible=icon]:hidden">
            DEV
          </span>
        ) : (
          <Chip
            text="BETA"
            variant="default"
            size="tag"
            className="bg-staticBlack text-staticWhite group-data-[collapsible=icon]:hidden"
          />
        )}
        <SidebarTrigger />
      </div>
    </div>
  )
}
